import * as React from "react";
import { useGlobalStores } from "../../../../hooks/use_global_stores";
import {Box, useTheme, styled, useMediaQuery} from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { ISnapshotV3 } from "../../../../config/snapshot";
import "../../../../utils/number_extensions";
import { useDrawingArea } from "@mui/x-charts";

interface IMonthlyChartProps {
    snapshot: ISnapshotV3;
}

const StyledText = styled('text')(({ theme }) => ({
    fill: theme.palette.primary.contrastText,
    textAnchor: 'middle',
    dominantBaseline: 'central',
    fontSize: 16,
    fontWeight: 100,
}));
  
const PieCenterLabel = ({ children }: { children: React.ReactNode }) => {
    const { width, height, left, top } = useDrawingArea();
    return (
        <StyledText x={left + width / 2} y={top + height / 2}>
            {children}
        </StyledText>
    );
};

export const MonthlyChart = ({snapshot}: IMonthlyChartProps) => {
    const { currencyStore } = useGlobalStores();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // changing the size means changing the radius values, etc.
    // Use AI for it, it's freaking weird.
    const size = 150;

    return (
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: size}}>
            <PieChart
                series={[
                    {
                        data: [
                            {
                                value: snapshot.amount,
                                label: 'Expenses this month',
                                color: theme.palette.primary.contrastText,
                            },
                            {
                                value: snapshot.monthly_recurring_expense,
                                label: 'Monthly recurring expense',
                                color: theme.palette.primary.light,
                            },
                            {
                                value: snapshot.income_left,
                                label: 'Money left',
                                color: theme.palette.primary.dark,
                            },
                        ],
                        innerRadius: isSmallScreen ? 56 : 60,
                        outerRadius: isSmallScreen ? 65 : 70,
                        paddingAngle: 3,
                        cornerRadius: 5,
                        startAngle: 0,
                        endAngle: 360,
                        valueFormatter: (v: any) => {
                            return v.value.toCurrency(currencyStore.currentCurrency, {});
                        },
                    }
                ]}
                hideLegend
                sx={{
                    '& .MuiPieArc-root': {
                        stroke: 'none'
                    }
                }}
                height={size}
                margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
            >
                <PieCenterLabel>
                    {Math.round((snapshot.income_left / snapshot.income_total) * 100)}% left
                </PieCenterLabel>
            </PieChart>
        </Box>
    );
};
